// extracted by mini-css-extract-plugin
module.exports = {"fullHeightContainer":"HomePageSeedComponent_fullHeightContainer__1cllO","flexRow":"HomePageSeedComponent_flexRow__Bz349","staticRow":"HomePageSeedComponent_staticRow__3Ymtw"};